import { BellIcon } from "@heroicons/react/24/outline";
import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import { useNotifications } from "../../context/NotificationContext";
import { useNotificationHandlers } from "../../hooks/useNotificationHandlers";
import NotificationFooter from "../notifications/NotificationFooter";
import NotificationHeader from "../notifications/NotificationHeader";
import NotificationList from "../notifications/NotificationList";

const NotificationsDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    notifications,
    unreadCount,
    loading,
  } = useNotifications();

  const {
    handleMarkAsRead,
    handleMarkAllAsRead,
    handleRemove,
    handleClearAll,
  } = useNotificationHandlers();

  // Handler for toggle dropdown
  const handleToggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // Handler for close dropdown
  const handleCloseDropdown = () => {
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={handleToggleDropdown}
        className={`relative p-2 rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
          isOpen
            ? "bg-blue-50 text-blue-600"
            : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"
        }`}
        aria-label="Notifications"
      >
        <BellIcon className="h-5 w-5" />
        {unreadCount > 0 && (
          <span className="absolute right-1 top-1 flex h-4 w-4 items-center justify-center rounded-full bg-error-500 text-[10px] font-bold text-white">
            {unreadCount > 99 ? "99+" : unreadCount}
          </span>
        )}
      </button>

      <AnimatePresence>
        {isOpen && (
          <>
            {/* Backdrop for closing dropdown when clicking outside */}
            <div
              className="fixed inset-0 z-10"
              onClick={handleCloseDropdown}
            />

            <motion.div
              initial={{ opacity: 0, y: 10, scale: 0.95 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 10, scale: 0.95 }}
              transition={{ duration: 0.2 }}
              className="absolute right-0 z-20 mt-2 w-80 rounded-md bg-white shadow-lg dark:bg-gray-800"
            >
              <NotificationHeader
                unreadCount={unreadCount}
                loading={loading}
                onMarkAllAsRead={handleMarkAllAsRead}
              />

              <NotificationList
                notifications={notifications}
                loading={loading}
                onMarkAsRead={handleMarkAsRead}
                onRemove={handleRemove}
              />

              <NotificationFooter
                notifications={notifications}
                loading={loading}
                onClearAll={handleClearAll}
              />
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default NotificationsDropdown;
